export default __webpack_public_path__ + "static/media/movipack_feature2.3f9f92d1.svg";